export const MIN_HEIGHT = 208
